import { IIconProps } from "./types"

export default function IconVec4(props: IIconProps) {
  const width = props.size || props.width || 31
  const height = props.size || props.height || 24
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 31 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08981 7.40551L5 2.2645L20.7697 0L24.1982 7.25337L6.08981 7.40551Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.28475 9.74346L18.4092 14.0282L15.9077 19.6681L0 12.8252L1.32682 6L4.0336 6.55198L4.28475 9.74346Z"
        fill="#3A3939"
      />
      <path
        d="M24.8379 15C24.943 18.1636 23.3908 21.0615 20.7701 22.608"
        stroke="#3A3939"
        stroke-width="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8286 15.7815L27.8902 15.7715L24.8804 11.0005L21.9306 15.8115L24.0022 15.7915L25.8286 15.7815Z"
        fill="#3A3939"
      />
    </svg>
  )
}
